import * as THREE from 'three';
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js';

// No bloom — too expensive on this hardware budget. Just a final pass for
// vignette + faint grain to give the image cinema texture without the cost.
const FinalShader = {
  uniforms: {
    tDiffuse:   { value: null },
    uVignette:  { value: 0.85 },
    uGrain:     { value: 0.035 },
    uTime:      { value: 0 }
  },
  vertexShader: /* glsl */`
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: /* glsl */`
    uniform sampler2D tDiffuse;
    uniform float uVignette;
    uniform float uGrain;
    uniform float uTime;
    varying vec2 vUv;

    float rand(vec2 co) {
      return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
    }

    void main() {
      vec4 col = texture2D(tDiffuse, vUv);
      vec2 q = vUv - 0.5;
      float v = 1.0 - dot(q, q) * uVignette;
      col.rgb *= v;
      float g = (rand(vUv + uTime * 0.001) - 0.5) * uGrain;
      col.rgb += g;
      gl_FragColor = col;
    }
  `
};

export function createComposer(renderer, scene, camera) {
  const composer = new EffectComposer(renderer);
  composer.setPixelRatio(Math.min(window.devicePixelRatio, 1));
  composer.setSize(window.innerWidth, window.innerHeight);

  const renderPass = new RenderPass(scene, camera);
  composer.addPass(renderPass);

  const finalPass = new ShaderPass(FinalShader);
  finalPass.renderToScreen = true;
  composer.addPass(finalPass);

  function resize() {
    composer.setSize(window.innerWidth, window.innerHeight);
  }
  function setTime(t) {
    finalPass.uniforms.uTime.value = t;
  }
  return { composer, finalPass, resize, setTime };
}
